import React from "react";
import type {FunctionComponent} from "react";
import {WhenUser} from "../../../modules/conditional/when-user/WhenUser";

export interface IWhenUserHasSongLibraryAccessProps {
  not?: boolean;
}

export const WhenUserHasSongLibraryAccess: FunctionComponent<IWhenUserHasSongLibraryAccessProps> = ({children, not}) => {
  if (!!not) {
    return <WhenUser membershipGiveSongAccess={false} >{children}</WhenUser>;
  }
  return <WhenUser isMember={true} membershipGiveSongAccess={true} >{children}</WhenUser>;
}

